<template>
  <div
    class="upcoming-event"
    data-category="event-card"
    :data-type="eventType"
  >
    <ul
      class="upcoming-event-time"
    >
      <li v-if="eventTime">
        {{ eventTime }}
      </li>
      <li
        v-for="(time, index) in event.Dates"
        :key="`${event.eventTitle}-extra-time-${index}`"
      >
        {{ time.extraDate }} // {{ time.eventStartTime }} - {{ time.eventEndTime }}
      </li>
    </ul>
    <div class="upcoming-event-title">
      {{ event.eventTitle }}
    </div>
    <div
      v-if="event.eventImage"
      class="upcoming-event-image"
    >
      <picture
        :key="`${event.eventId}-image`"
        v-lazyload="{ src: event.eventImage,
                      variant: 'upcoming-events' }"
        class="image-wrapper"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="event.eventImageAlt"
        >
      </picture>
    </div>
    <div class="upcoming-event-content">
      <div class="upcoming-event-type">
        <div
          v-if="eventType"
          class="label"
        >
          {{ eventType }}
        </div>
        <div class="time">
          {{ eventTime }}
        </div>
      </div>
      <div class="upcoming-event-title">
        {{ event.eventTitle }}
      </div>
      <div
        class="upcoming-event-description"
        v-html="formattedDescription.text"
      />
      <button
        v-if="formattedDescription.isTruncated"
        type="button"
        data-category="toggle-description"
        :data-state="showFullDescription ? 'expanded' : 'collapsed'"
        :class="['toggle-button', 'button', showFullDescription ? 'less' : 'more']"
        @click.prevent="toggleDescriptionVisibility"
      >
        {{ showFullDescription ? dictionary['upcoming-events:see-less'] : dictionary['upcoming-events:see-more'] }}
      </button>
    </div>
    <div class="upcoming-event-actions">
      <a
        v-if="event.secondaryCtaUrl"
        class="upcoming-event-cta-secondary"
        :href="event.secondaryCtaUrl"
        :target="event.secondaryCtaTarget"
        data-category="cta"
        :data-cta="toCamelCase(event.secondaryCtaLabel)"
      >
        {{ event.secondaryCtaLabel }}
      </a>
      <a
        v-if="event.primaryCtaUrl"
        class="upcoming-event-cta-primary"
        :href="event.primaryCtaUrl"
        :target="event.primaryCtaTarget"
        data-category="cta"
        :data-cta="toCamelCase(event.primaryCtaLabel)"
      >
        {{ event.primaryCtaLabel }}
      </a>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import truncate from 'html-truncate'
  import { toCamelCase } from '@utils/string-helpers'

  export default {
    name: 'EventCard',
    props: {
      dictionary: {
        type: Object,
        required: true,
        default: () => ({})
      },
      event: {
        type: Object,
        required: true,
        default: () => ({})
      },
    },
    data() {
      return {
        showFullDescription: false,
        descMaxLength: 160
      }
    },
    computed: {
      ...mapState('responsive', { wWidth: 'width' }),
      ...mapGetters('i18n', ['tc']),

      eventType() {
        return this.event.eventTypes.name
      },

      eventTime() {
        return this.event.eventEndTime ? `${this.event.eventStartTime} - ${this.event.eventEndTime}` : `${this.event.eventStartTime}`
      },

      isMobile() {
        return this.wWidth < 1024
      },

      formattedDescription() {
        const isTruncated = this.event.eventDescription && this.event.eventDescription.length > this.descMaxLength
        const text = !this.showFullDescription && isTruncated
          ? truncate(this.event.eventDescription, this.descMaxLength)
          : this.event.eventDescription
        return { text, isTruncated }
      }
    },
    methods: {
      toCamelCase,
      toggleDescriptionVisibility() {
        this.showFullDescription = !this.showFullDescription
      },
    }
  }
</script>
